import {useTranslation} from "next-i18next";
import React, {useState} from "react";
import {ObjectInterfaceWithCity} from "../../interfaces/ObjectInterface";
import {calcIconGallery} from "../CalculationHelper/CalcHelpers";
import BookingCalendar from './BookingCalendar';

interface ObjectDetailsProps {
	object: ObjectInterfaceWithCity;
	bookedDates?: { start: Date; end: Date }[];
	locale?: string;
	location?: string;
	startDate?: Date | null;
	endDate?: Date | null;
}

function ObjectDetails({object, bookedDates, locale, startDate, endDate}: ObjectDetailsProps) {
	const [showMore, setShowMore] = useState(false);
	const {t} = useTranslation();
	const iconGallery = calcIconGallery(object, t);
	return (
		<div className="">
			{/* <BookingCalendar
				bookedDates={bookedDates}
				locale={locale}
				startDate={startDate}
				endDate={endDate}
			/> */}
			<h3 className="mb-6 font-light text-[40px]">{t("components.objectDetails.description")}</h3>
			<p
				className={`text-[16px] md:columns-2 ${
					showMore ? "h-auto" : "h-[150px] md:h-auto overflow-hidden"
				}`}
			>
				{object.info}
			</p>
			<p
				onClick={() => setShowMore(!showMore)}
				className={`md:after:invisible md:invisible after:absolute after:bottom-6 after:left-0 after:h-[100px] after:w-full after:bg-[linear-gradient(rgba(255,255,255,0.0),rgba(255,255,255,0.8),white)] relative !mb-16 text-[16px] font-bold ${
					showMore && "after:invisible"
				} cursor-pointer`}
			>
				{showMore ? "Weniger anzeigen" : "Mehr anzeigen"}
			</p>
			<div className="grid gap-3 grid-cols-[repeat(auto-fit,250px)] place-content-between">
				{iconGallery.map((icon) => (
					<div key={icon.name} className="flex flex-row gap-5">
						<div className="w-6 h-6">{icon.icon}</div>
						<p className="text-[16px] whitespace-nowrap">{t(icon.name)}</p>
					</div>
				))}
			</div>
		</div>
	);
}

export default ObjectDetails;
